<template>
  <div>
  <v-card class="elevation-12 ">
    <v-toolbar
        color="#488ba6"
        dark
        flat
    >
      <v-toolbar-title>Step 1: Select Membership Type</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-radio-group v-model="state.member.app.membershipType" column>

          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Membership Type</th>
                <th class="text-left">Application/Dues Fee</th>
                <th class="text-left">Choice</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(type, index) in state.member.app.membershipTypes" :key="index" class="ma-4">
                <td class="text-left">
                  <v-dialog v-model="type.dialog_open">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn

                          color="#488ba6"
                          dark
                          small
                          outlined
                          v-bind="attrs"
                          v-on="on"
                      >
                        {{ type.text }} Membership
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="headline">{{ type.text }} Membership</v-card-title>
                      <v-card-text v-html="type.membership_description"></v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="type.dialog_open = false">
                          Close
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </td>
                <td class="text-left">{{
                    new Intl.NumberFormat('en-US', {
                      style: 'currency', currency:
                          'USD'
                    }).format(type.fee)
                  }}
                </td>

                <td class="text-left">
                  <v-radio :value="type"></v-radio>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-radio-group>
      </v-form>
      <p>If you have retired and would like to be considered for Retired Status, send a request to <a href="mailto:membership@fvs.org">membership@fvs.org</a></p>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#488ba6" @click="setupForm" style="color:white">Continue</v-btn>
    </v-card-actions>
  </v-card>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "MembershipType",
  data: function () {
    return {
      sent: false,
      dialog: false
    }
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
  },
  methods: {
    setupForm: function () {
      this.sent = true;
      this.$store.commit('setupForm')
      this.sent = false;
    }
  },
}
</script>

<style scoped>

</style>